<template>
  <div>
    <el-dialog
      v-if="showForm.basic"
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="用户记录详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">头像:</el-col>
        <el-col :span="19"><el-avatar shape="square" :size="50" :src="showForm.basic.avatar"></el-avatar></el-col>
      </el-row>
      <el-row>
        <el-col :span="5">微信昵称:</el-col>
        <el-col :span="19">
          {{ showForm.basic.name }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">
          {{ showForm.basic.deviceTitle }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">评价（展示/回复）:</el-col>
        <el-col :span="19">
          {{ showForm.basic.rankTime ? '是' : '否' }} / {{ showForm.basic.rankRecordTime ? '是' : '否' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付（展示/支付）:</el-col>
        <el-col :span="19">
          {{ showForm.basic.paymentTime ? '是' : '否' }} / {{ showForm.basic.paymentRecordTime ? '是' : '否' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">问卷（展示/全部回复）:</el-col>
        <el-col :span="19">
          {{ showForm.basic.questTime ? '是' : '否' }} / {{ showForm.basic.questRecordTime ? '是' : '否' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">广告（展示/观看）:</el-col>
        <el-col :span="19">
          {{ showForm.basic.advertiseTime ? '是' : '否' }} / {{ showForm.basic.advertiseRecordTime ? '是' : '否' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">剩余体验时间:</el-col>
        <el-col :span="19">
          {{ (showForm.basic.paymentRecordTime && showForm.basic.questRecordTime && showForm.basic.advertiseRecordTime) ? '无限' : showForm.basic.availableDuration }} 分钟
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">注册时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { findProfile } from '@/api/alfmeier'
export default {
  name: 'AlfmeierProfileDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const profileId = row.profileId
      this.row = row
      const data = await findProfile({
        profileId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
